/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  HcpLandscapeRow,
  HcpLandscapeRowFromJSON,
  HcpLandscapeRowFromJSONTyped,
  HcpLandscapeRowToJSON,
} from "./";

/**
 *
 * @export
 * @interface HcpLandscapeRowIEnumerableControllerResponse
 */
export interface HcpLandscapeRowIEnumerableControllerResponse {
  /**
   *
   * @type {Array<HcpLandscapeRow>}
   * @memberof HcpLandscapeRowIEnumerableControllerResponse
   */
  data?: Array<HcpLandscapeRow> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof HcpLandscapeRowIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function HcpLandscapeRowIEnumerableControllerResponseFromJSON(
  json: any,
): HcpLandscapeRowIEnumerableControllerResponse {
  return HcpLandscapeRowIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function HcpLandscapeRowIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HcpLandscapeRowIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(HcpLandscapeRowFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function HcpLandscapeRowIEnumerableControllerResponseToJSON(
  value?: HcpLandscapeRowIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(HcpLandscapeRowToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
